<template>
    <span v-if="mostrarBtn">
        <b-button variant="warning" @click.stop="confirmarRetornarPagamento()">
            <span> <i class="fa fa-undo"></i> Retornar Pagamento </span>
        </b-button>
    </span>

</template>

<script>
import { pagamentoStatus } from './PagamentoStatus';

export default {
    props: {
        pagamento: {
            type: Object,
            default: () => ({})
        },

        pagamentosServicos: {
            type: Object,
            default: () => ({})
        }
    },

    methods: {
        confirmarRetornarPagamento() {
            this.$swal({
                title: `Registro de Pagamento`,
                html: `Confirma o retorno do registro de pagamento?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.retornarPagamento()
                }
            })
        },

        retornarPagamento() {
            this.$store.dispatch('addRequest')
            this.pagamentosServicos.retornarPagamento(this.pagamento.pagamentoId).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Pagamento retornado para a UABS',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('obterPagamentoAtualizado')
                    }
                    else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    computed: {
        mostrarBtn() {
            return this.$route.name == 'DespesasGerais_Finalizacao_Pagamentos_Detalhar'
                && this.$temAcessoView('DESP-GERAIS-FINAL-PAG-02')
                && this.pagamento.status == pagamentoStatus.AGUARDANDO_SETOR_FINANCEIRO
        }
    }
}
</script>